import { render, staticRenderFns } from "./ImportButtonV2.vue?vue&type=template&id=1d0c6a3a"
import script from "./ImportButtonV2.vue?vue&type=script&lang=js"
export * from "./ImportButtonV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports